export const pluralize = (word: string, count: number): string => {
  if (count === 1) {
    return word;
  }
  if (/(s|x|z|ch|sh)$/.test(word)) {
    return `${word}es`;
  }
  return `${word}s`;
};
